import { useEffect, useRef, useState } from "react";
/** Keep the native picker open while adjusting; save only its committed change. */
export function BoardColorInput({
  value,
  label,
  disabled,
  onCommit,
}: {
  value: string;
  label: string;
  disabled: boolean;
  onCommit: (value: string) => void;
}) {
  const input = useRef<HTMLInputElement>(null),
    commit = useRef(onCommit);
  commit.current = onCommit;
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  useEffect(() => {
    const el = input.current;
    if (!el) return;
    const changed = () => commit.current(el.value);
    el.addEventListener("change", changed);
    return () => el.removeEventListener("change", changed);
  }, []);
  return (
    <input
      ref={input}
      type="color"
      aria-label={label}
      value={draft}
      disabled={disabled}
      onChange={(e) => setDraft(e.target.value)}
    />
  );
}
